import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import {ProjectSystemType} from "../../../../../../../core/model2/project/types"
import {ViewTypeConfigs} from "../../../../../../../core/gd/const/views/view-type-config"
import project_getDefaultViewTypes from "./functions/get-default-view-types"
import FieldsFactory from "../../../../../../../core/fields3/fields-factory";
import {FieldType} from "../../../../../../../core/fields3/field-type";
import FieldFormElement from "../../../../../../../core/fields3/render/form-elemnent";

type Props = {
    form       : FormManager
    systemType : ProjectSystemType
}

export default function FormDefaultViewSelector(props: Props) {
    const defaultViewTypes = project_getDefaultViewTypes(props.systemType)
    const defaultViewsOptions = _.map(defaultViewTypes, viewType=>{
        const viewTypeConfig = ViewTypeConfigs[viewType]
        return {
            icon    : viewTypeConfig?.icon,
            label   : viewTypeConfig?.name,
            value   : viewType
        }
    })

    const field = FieldsFactory.get({
        fieldId         : "defaultView",
        type            : FieldType.DROPDOWN,
        options         : defaultViewsOptions,
        noValueOption   : false,
        showMenuMore    : false
    })

    return (
        <div className="row">
            <div className="label">Default view</div>
            <div className="element">
                <FieldFormElement field={field} form={props.form} options={{showIcon: true}}/>
                <FormError form={props.form} name="defaultView"/>
            </div>
        </div>
    )
}
